
import React, { createContext, useContext, ReactNode } from 'react';
import { useStore } from '../hooks/useStore';
import { Store } from '../types';

/**
 * StoreContext: Pure application mein store ki 'Identity' aur 'Branding' maintain rakhta hai.
 */
interface StoreContextType {
  store: Store | null;
  isLoading: boolean;
  brandingStyles: React.CSSProperties;
  isDefault: boolean;
}

const StoreContext = createContext<StoreContextType | undefined>(undefined);

export const StoreProvider: React.FC<{ children: ReactNode; slug?: string }> = ({ children, slug }) => {
  const storeData = useStore(slug);

  return (
    <StoreContext.Provider value={storeData}>
      {/* 
         Injected Styles: Ye div pure app ke CSS variables ko control karta hai.
         Tailwind colors ab 'var(--lynqar-primary)' se link ho jayenge.
      */}
      <div style={storeData.brandingStyles} className="contents">
        {children}
      </div>
    </StoreContext.Provider>
  );
};

/**
 * useStoreContext: Components is hook ka use karke current store ki info nikal sakte hain.
 */
export const useStoreContext = () => {
  const context = useContext(StoreContext);
  if (context === undefined) {
    throw new Error('useStoreContext must be used within a StoreProvider');
  }
  return context;
};
